/* unplugin-vue-components disabled */import script from "./taskList.vue?vue&type=script&lang=ts&setup=true"
export * from "./taskList.vue?vue&type=script&lang=ts&setup=true"

import "./taskList.vue?vue&type=style&index=0&id=41932922&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41932922"]])

export default __exports__